import { render, staticRenderFns } from "./PeppolActions.vue?vue&type=template&id=76cb1fcb&scoped=true&"
import script from "./PeppolActions.vue?vue&type=script&lang=ts&"
export * from "./PeppolActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb1fcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76cb1fcb')) {
      api.createRecord('76cb1fcb', component.options)
    } else {
      api.reload('76cb1fcb', component.options)
    }
    module.hot.accept("./PeppolActions.vue?vue&type=template&id=76cb1fcb&scoped=true&", function () {
      api.rerender('76cb1fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PeppolActions.vue"
export default component.exports